import {HttpHeaders} from '@angular/common/http';

export abstract class BaseUserService {

  public createHeaders(token: string) {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
  }

}
